// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2194":"3071d521","5920":"9d0f9c75","6424":"c7f252fe"}[chunkId] + ".chunk.css");